import { firebase } from "firebaseui-angular";
const samlProvider = {
  provider: new firebase.auth.SAMLAuthProvider("saml.maitland-prod").providerId,
  //Change the button label with following param
  providerName: "Okta - Maitland Newcastle Diocese",
};


export default samlProvider;
